import {
  ClientGeoAreaGeoAreaTypeEnum,
  type ClientGeoArea
} from '@DigitaleDoerfer/digitale-doerfer-api';

import { isEmptyOrNull } from '@/shared/utils/string';

export const getLeafs = (
  geoAreas: readonly ClientGeoArea[],
  parent: string = ''
): (ClientGeoArea & { parents?: string })[] =>
  geoAreas.flatMap((geoArea) => {
    let parents = parent;
    if (geoArea.leaf) {
      return { ...geoArea, parents };
    }
    if (geoArea.childGeoAreas) {
      if (geoArea.geoAreaType !== ClientGeoAreaGeoAreaTypeEnum.Nation)
        parents = `${parents}${isEmptyOrNull(parents) ? '' : ' > '}${geoArea.name}`;
      return getLeafs(geoArea.childGeoAreas, parents);
    }
    return [];
  });
